import { http } from "./config";
import authHeader from "./auth-header";

const URL_BASE = "/api/fluxo-alocacoes";

export default {
  listar() {
    return http.get(URL_BASE, {
      headers: authHeader(),
    });
  },

  listarTodas() {
    return http.get(`${URL_BASE}/todas`, {
      headers: authHeader(),
    });
  },

  buscarPorId(id) {
    return http.get(`${URL_BASE}/${id}`, {
      headers: authHeader(),
    });
  },

  criar(dto) {
    return http.post(URL_BASE, dto, {
      headers: authHeader(),
    });
  },

  editar(id, dto) {
    return http.put(`${URL_BASE}/${id}`, dto, {
      headers: authHeader(),
    });
  },

  excluir(id) {
    return http.delete(`${URL_BASE}/${id}`, {
      headers: authHeader(),
    });
  },

  listarEtapas(fluxo) {
    return http.get(`${URL_BASE}/fluxos/${fluxo}/etapas`, {
      headers: authHeader(),
    });
  },

  listarColaboradoresAtivos() {
    return http.get(`${URL_BASE}/colaboradores/ativos`, {
      headers: authHeader(),
    });
  },
};
